"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Image = _interopRequireDefault(require("./../Image"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Title = _interopRequireDefault(require("../../Title"));

var _CommonContainer = _interopRequireDefault(require("../../CommonContainer"));

var _utils = require("../../utils");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var IMG_URL_TYPE = ['https://staticintl.cloudcachetci.com/cms/backend-cms/76YU478_Untitled.jpg', 'https://staticintl.cloudcachetci.com/cms/backend-cms/iAGJ617_Untitled-1.jpg', 'https://staticintl.cloudcachetci.com/cms/backend-cms/W5Pd973_Untitled-2.jpg'];

function Video(props) {
  var data = props.data,
      kindType = props.type,
      _a = props.hasTopPadding,
      hasTopPadding = _a === void 0 ? false : _a,
      flexTitle = props.flexTitle,
      desc = props.desc,
      flexSmallTitle = props.flexSmallTitle,
      mergeComponentStatus = props.mergeComponentStatus;

  var _b = data || {},
      title = _b.title,
      _c = _b.configuration,
      configuration = _c === void 0 ? [] : _c;

  if (configuration.length < 1) {
    return null;
  }

  var descRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    var descDome = descRef.current;
    (0, _utils.windowAddEventListener)(function (status) {
      if (status) {
        Array.from(descDome.childNodes).forEach(function (item) {
          var _a, _b, _c, _d, _e, _f, _g;

          var getClassNameDome = ((_e = (_d = (_c = (_b = (_a = item.childNodes[0]) === null || _a === void 0 ? void 0 : _a.childNodes[0]) === null || _b === void 0 ? void 0 : _b.childNodes[0]) === null || _c === void 0 ? void 0 : _c.childNodes[0]) === null || _d === void 0 ? void 0 : _d.childNodes[0]) === null || _e === void 0 ? void 0 : _e.childNodes[1]) || {
            style: {}
          };

          if (((_g = (_f = item.childNodes[0]) === null || _f === void 0 ? void 0 : _f.childNodes[1]) === null || _g === void 0 ? void 0 : _g.clientHeight) > 60) {
            getClassNameDome.style.top = '-33px';
          } else {
            getClassNameDome.style.top = '-13px';
          }
        });
      }
    }, 1);
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, (flexTitle || desc || flexSmallTitle) && /*#__PURE__*/_react["default"].createElement(_Title["default"], {
    title: flexTitle,
    desc: desc,
    mergeComponentStatus: mergeComponentStatus,
    flexSmallTitle: flexSmallTitle
  }), /*#__PURE__*/_react["default"].createElement("section", {
    className: (0, _classnames["default"])('product-resource-container--video', {
      'has-no-padding-top': !hasTopPadding
    })
  }, title && /*#__PURE__*/_react["default"].createElement("h3", {
    className: 'h3'
  }, title), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'product-resource-container__card',
    ref: descRef
  }, configuration.map(function (item, index) {
    var description = item.description,
        type = item.type,
        videoBgUrl = item.videoBgUrl,
        videoPlayUrl = item.videoPlayUrl,
        img = item.img;
    var imgUrl = (0, _utils.fomateFileData)(img).url;
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: index,
      className: 'list'
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: 'list-div'
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: type === 'right' ? {
        backgroundImage: "url(" + (!imgUrl ? IMG_URL_TYPE[index % 3] : imgUrl) + ")",
        backgroundSize: '100%'
      } : {
        background: 'black'
      },
      className: (0, _classnames["default"])('video-list', {
        'video-list-type-right': type === 'right'
      })
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('scale-class', {
        'scale-class--right': type === 'right'
      })
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: 'scale-video'
    }, /*#__PURE__*/_react["default"].createElement(_Image["default"], {
      width: 448,
      height: 252,
      filedVideoBg: videoBgUrl || 'https://staticintl.cloudcachetci.com/cms/backend-cms/video.MP4',
      filedVideoList: videoPlayUrl,
      source: type === 'right' ? '' : img || 'https://staticintl.cloudcachetci.com/cms/backend-cms/video.MP4',
      record: item
    })))), /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('bottom', {
        'bottom-type-right': type === 'right',
        'bottom-type': type !== 'right',
        'bottom-type--cyan': ['cyan'].includes(kindType)
      })
    }, /*#__PURE__*/_react["default"].createElement("span", null, description))));
  }))));
}

var ResourceVideo = function ResourceVideo(props) {
  var paddingTopNum = props.paddingTopNum,
      paddingBottomNum = props.paddingBottomNum,
      flexTitle = props.flexTitle,
      style = props.style,
      isFooterPart = props.isFooterPart,
      isCombination = props.isCombination,
      isPadding = props.isPadding;
  return /*#__PURE__*/_react["default"].createElement(_CommonContainer["default"], {
    paddingTopNum: paddingTopNum,
    paddingBottomNum: paddingBottomNum,
    flexTitle: flexTitle,
    style: style,
    isPadding: isPadding,
    isFooterPart: isFooterPart,
    isCombination: isCombination
  }, /*#__PURE__*/_react["default"].createElement(Video, __assign({}, props)));
};

var _default = ResourceVideo;
exports["default"] = _default;